<app-gabarit-confirmation (systemesEnErreur)="onSystemesEnErreurChange($event)">
  <span class="dsd-t-4" confirmation-titre>
    {{
      (isAjout ? 'confirmation.courriel.titreAjout' : 'confirmation.courriel.titreModification')
        | translate
    }}
  </span>
  <span class="dsd-t-4" confirmation-titre-partiel>
    {{
      (isAjout
        ? 'confirmation.courriel.titreAjoutPartiel'
        : 'confirmation.courriel.titreModificationPartiel'
      ) | translate
    }}
  </span>
  <span confirmation-partiel-contexte>
    {{ 'confirmation.partiel.courriel' | translate }}
  </span>
  <div #steps>
    <p id="dgag">{{ 'confirmation.etapes.rappelDGAG' | translate }}</p>
  </div>
</app-gabarit-confirmation>
